import { useEffect, useState } from 'react';
import { fetchPastChampions } from '../services/firestore';
import AppHeader from './AppHeader';
import './Leaderboard.css';

const MEDALS = ['🥇', '🥈', '🥉'];

// weekId is already an unambiguous "2026-W33" — just surfaced as "Week 33,
// 2026" rather than doing extra date math to turn it into a calendar range.
function formatWeekLabel(weekId) {
  const [year, week] = weekId.split('-W');
  return `Week ${Number(week)}, ${year}`;
}

// Reuses Leaderboard.css's card/row classes directly rather than
// introducing a separate visual language — this is the same leaderboard
// look, just scoped to one closed week's top 3 at a time.
function PastChampions({ onBack }) {
  const [weeks, setWeeks] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    fetchPastChampions()
      .then((list) => {
        if (!cancelled) setWeeks(list);
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) setError('Could not load past champions.');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="page">
      <div className="panel">
        <AppHeader
          subtitle="Past Champions"
          topRight={<span style={{ fontSize: 20 }}>🏛️</span>}
          middleItems={['Top 3 from each closed week', 'Best 5 tournament results per week']}
          bottomLeft="A new week starts fresh every Monday 00:00 UTC"
        />

        <div className="home-body single">
          <div className="home-right">
            <button className="btn-ghost" onClick={onBack}>
              ← Back
            </button>

            {error && <p className="error">{error}</p>}
            {!error && weeks === null && <p className="hint">Loading…</p>}
            {weeks?.length === 0 && <p className="hint">No closed weeks yet — check back after this week ends.</p>}

            {weeks?.map((week) => (
              <div className="card leaderboard-card" key={week.id}>
                <h3>{formatWeekLabel(week.weekId)}</h3>
                {(week.top3 || []).map((entry, index) => (
                  <div className="leaderboard-row" key={entry.uid}>
                    <div className="leaderboard-rank">{MEDALS[index] || `#${entry.rank}`}</div>
                    <div className="leaderboard-name">{entry.displayName || 'Player'}</div>
                    <div className="leaderboard-points">{entry.weeklyScore} pts</div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PastChampions;
